export const getCurrentUser = state => state.currentUser.get('currentUser');
export const getIsFetching = state => state.currentUser.get('isFetching');
export const getIsLoading = state => state.currentUser.get('isFetching');
export const getErrors = state => state.currentUser.get('errors');
